
// Spolecne scripty seznamu WFL 
// JSindelka
namespace Gordic.Pod.Lists
{
    @Decorators.gcontent
    export class PodListBaseAC extends GContentBase<Gordic.Wfl.ListAC.WflListBaseAC> 
    {
        ImageDelegateStavPodani: ObjectLiteral<Gordic.Wfl.WebClient.GIcon> = {};
        ImageDelegateStavRozlozeni: ObjectLiteral<Gordic.Wfl.WebClient.GIcon> = {};
        GEXVisible: boolean = false;
        DSXVisible: boolean = false;
        PsrSKVisible: boolean = false;

        public static InitList(content: GContentType<PodListBaseAC>): void
        {
            Gordic.Wfl.ListAC.WflListBaseAC.InitList(content);
            Gordic.Wfl.ListAC.WflListBaseAC.AddBaseActionsToMenu(content);
        }

        public static CreateActionOdeslatPotvrzeniODoruceni(content: GContentType<PodListBaseAC>, favorite?: boolean): GAction {
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.odeslatPotvrzeniODoruceni,
                icon: Gordic.Gin.Icons.ActionEnum.odeslat,
                caption: "jres:23900071", //RC 23900071 : Odeslat potvrzení o doručení
                tooltip: "jres:23900071",
                run: function (ev, ctx) {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content); 
                    Gordic.Pod.Dialogs.OdeslaniPotvrzeniODoruceniDlg(content, { IdEntity: rowData.ixb }, Global.Enums.ModOtevreni.showModalWindow);
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionZobrazitPotvrzeniODoruceni(content: GContentType<PodListBaseAC>, favorite?: boolean): GAction {
            var action = new GAction({
                name: Gordic.Pod.Globals.ActionsName.infoODoruceni,
                icon: Gordic.Pod.Icons.ActionEnum.infoODoruceni,
                caption: "jres:23900060", //RC 23900060 : Zobrazit potvrzení o doručení
                run: function (ev, ctx)
                {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content); 
                    if (rowData) Gordic.Pod.Dialogs.OpenPotvrzeniODoruceniDlg(content, { IdEntity: rowData.ixb }, Global.Enums.ModOtevreni.showModalWindow);
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionZobrazitZpravu(content: GContentType<PodListBaseAC>, favorite?: boolean): GAction {
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.ZobrazitSoubor,
                icon: Gordic.Gin.Icons.ActionEnum.zobrazitSoubor,
                caption: "jres:23900248", //RC 23900248 : Zobrazit zprávu
                run: function (ev, ctx) {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content);
                    if (rowData)
                    {
                        Wfl.AC.WflBaseAC.OpenElSouborZUloziste(content, rowData.ixb)
                    }
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static CreateActionUlozitZpravu(content: GContentType<PodListBaseAC>, favorite?: boolean): GAction {
            var action = new GAction({
                name: Gordic.Gin.Globals.Enums.ActionsName.Ulozit,
                icon: Gordic.Gin.Icons.ActionEnum.ulozit,
                caption: "jres:23900249", //RC 23900249 : Uložit zprávu
                run: function (ev, ctx) {
                    var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content);
                    if (rowData) {
                        Wfl.AC.WflBaseAC.OpenOrDownloadFile(content, rowData.ixb, true)
                    }
                }
            });
            if (favorite && favorite == true) action.update({ groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite });
            return action;
        }

        public static DoAkceElPodani(content: GContentType<PodListBaseAC>, Typ: Pod.Interface.TypAkceElPodani): void
        {
            var l_asSelected = Wfl.ListAC.WflListBaseAC.GetSelectedIxsDatZmena(content)
            if (l_asSelected.length > 0)
            {
                var l_dotaz = "";
                content.TypProvedeneAkce = Wfl.Interface.TypAkce.nespecifikovana;
                switch (Typ)
                {
                    case Pod.Interface.TypAkceElPodani.vratitKeZpracovani:
                        l_dotaz = "jres:23900066"
                        break;
                    case Pod.Interface.TypAkceElPodani.odstornovat:
                        l_dotaz = "jres:23900069" //RC 23900069 : Opravdu chcete odstornovat označená el. podání?
                        break;
                    case Pod.Interface.TypAkceElPodani.nastavitZpracovaniAutomat:
                        l_dotaz = "jres:23900101" //RC 23900101 : Opravdu chcete označit el. podání pro automatické zpracování?
                        break;
                    case Pod.Interface.TypAkceElPodani.nastavitZpracovaniManual:
                        l_dotaz = "jres:23900102" //RC 23900102 : Opravdu chcete označit el. podání pro manuální zpracování?
                        break;
                    case Pod.Interface.TypAkceElPodani.sloucitZpetRozlozena:
                        l_dotaz = "jres:23900104" //RC 23900104 : Opravdu chcete sloučit označená rozložená el. podání?
                        break;
                }

                if (l_dotaz !== "") // je dotaz
                {
                    content.dialogs.confirm("jres:23900067", l_dotaz).on("yes", (ev, obj) =>
                    { //RC 23900067 : Dotaz
                        PodListBaseAC.DoAkceElPodaniCall(content, l_asSelected, Typ)
                    });
                }
                else
                {
                    PodListBaseAC.DoAkceElPodaniCall(content, l_asSelected, Typ)
                }
            }
            else Wfl.ListAC.WflListBaseAC.ShowInfoNeniVybranZadnyRadek(content);
        }      

        public static DoAkceElPodaniCall(content: GContentType<PodListBaseAC>, Selected: Gin.Interface.GIxsDateTime[], Typ: Pod.Interface.TypAkceElPodani): void
        {
            content.call("DoAkceElPodani", { Selected: Selected, Typ: Typ })
                .done(function (r)
                {
                    Wfl.ListAC.WflListBaseAC.ResolveResultInfo(content, r)
                })
                .always(function () {
                    content.endOperation();
                });
        }   

        public static CreateActionSloucitZpetRozlozena(content: GContentType<PodListBaseAC>): GAction
        {
            var action = new GAction({
                name: Pod.Globals.ActionsName.sloucitZpetRozlozenaElPodani,
                icon: Gordic.Gin.Icons.ActionEnum.sdruzit,
                caption: "jres:23900103", //RC 23900103 : Sloučit zpět rozložená
                run: function (ev, ctx) {
                    PodListBaseAC.DoAkceElPodani(content, Pod.Interface.TypAkceElPodani.sloucitZpetRozlozena);
                }
            });
            return action;
        }

        public static CreateActionOdemknoutElPodani(content: GContentType<PodListBaseAC>): GAction {
            var action = new GAction({
                name: Pod.Globals.ActionsName.odemknoutElPodani,
                icon: Gordic.Pod.Icons.ActionEnum.odemknoutElPodani,
                caption: "jres:23900070", //RC 23900070 : Odemknout
                groupName: Gordic.Gin.Globals.Enums.ActionsGroupName.Favorite,
                run: function (ev, ctx) {
                    PodListBaseAC.DoAkceElPodani(content, Pod.Interface.TypAkceElPodani.odemknout);
                }
            });
            return action;
        }

        public static GetSelectedGIxsListOperationDto(content: GContentType<PodListBaseAC>): Wfl.Interface.GIxsListOperationDto[]
        {
            return content.mainGrid.ggrid("getSelection").map((o) => { return { IxsEntity: o.ixb, IxsOperation: o.ixp }; }) as Wfl.Interface.GIxsListOperationDto[];
        } 


        public static CreateActionAktualizaceMetadatOvereniElPodani(content: GContentType<PodListBaseAC>): GAction {
            var action = new GAction({
                name: Pod.Globals.ActionsName.aktualizaceMetadatOvereniElPodani,
                icon: Gordic.Gin.Icons.ActionEnum.opravit,
                caption: "jres:23900171", //RC 23900171 : Aktualizace metadat ověření
                run: function (ev, ctx)
                {
                    var l_selected = PodListBaseAC.GetSelectedGIxsListOperationDto(content)
                    if (l_selected.length > 1)
                    {

                        Dialogs.HromadnaOpravaMetadatOvereniDlg(content, {})
                            .done(function (ret) {
                                if (ret)
                                {
                                    content.resultInfo = [];
                                    PodListBaseAC.HromadneOpravitMetadatOvereni(content, l_selected, ret)
                                        .done(function ()
                                        {
                                            Wfl.ListAC.WflListBaseAC.ResolveResultInfo(content, content.resultInfo);
                                        })
                                        .always(function () {
                                            content.endOperation();
                                        });
                                }
                            })
                    }
                    else
                    {
                        var rowData = Wfl.ListAC.WflListBaseAC.GetActiveRow(content);
                        if (rowData) {
                            // 21.07.2020 - TFeik
                            // Odstranění zpomalovače.
                            if (rowData.ixp) {
                                Dialogs.OpravaMetadatOvereniDlg(content, { Ixp: rowData.ixp })
                            } else content.dialogs.warning("jres:23900172") //RC 23900172 : Toto el. podání ještě nebylo registrováno.
                        }
                    }
                }
            });
            return action;
        }

        public static HromadneOpravitMetadatOvereni(content: GContentType<PodListBaseAC>, _selected: Wfl.Interface.GIxsListOperationDto[], _model: Gordic.Pod.Interface.GHromadnaOpravaMetadatOvereniDto): JQuery.Promise<boolean> {

            let promis = $.Deferred<boolean>();
            content.PocetCelkem = _selected.length;

            if (content.PocetCelkem > 0) {
                content.Poradi = content.PocetCelkem;
                var promises: JQuery.Promise<any>[] = [];
                content.endOperation();

                for (var i = 0; i < _selected.length; i++) {
                    promises.push(PodListBaseAC.OpravitMetadataOvereni(content, _selected[i], _model));
                }

                $.when.apply(null, promises).done(
                    function () {
                        promis.resolve(true);
                    });
            }
            else { promis.resolve(false); }
            return promis.promise();
        }

        public static OpravitMetadataOvereni(content: GContentType<PodListBaseAC>, _item: Wfl.Interface.GIxsListOperationDto, _model: Gordic.Pod.Interface.GHromadnaOpravaMetadatOvereniDto): JQuery.Promise<boolean> {
            let promis = $.Deferred<boolean>();
            Gin.Globals.ShowWaitInfo(content, "jres:23900185" + " - " + _item.IxsOperation); //RC 23900185 : Probíhá aktualizace
            content.call<Gin.Interface.GResultInfo>("OpravaMetadatOvereni", { Item: _item, model: _model })
                .done(function (r) {
                    if (r) {
                        Wfl.ListAC.WflListBaseAC.AddResultInfo(content, r);
                        content.endOperation();
                        promis.resolve(true);
                    }
                    else {
                        content.endOperation();
                        promis.resolve(false);
                    }
                })
                .fail(function (retVal) {
                    Wfl.ListAC.WflListBaseAC.ResolveFaildRadku(content, _item.IxsEntity!, retVal.statusText);
                    promis.resolve(false);
                })
                .always(function () {
                    content.endOperation();
                });
            return promis.promise();
        }                   
    }
}


